import {
    Grid,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableBody,
} from "@mui/material";
import React from "react";
import {
    BaseGrid,
    StyledTableRow,
    TableCellHeader,
    TableCellWidth,
    TitleTypography,
} from "../KandidatViewPage";
import { RiwayatPekerjaanResponse } from "../../../models/RiwayatPekerjaan";
import {ReferensiByIDResponse} from "../../../models/Kandidat";

type Props = { data: ReferensiByIDResponse[] };

export default function DataReferensiKandidatPage({ data }: Props) {
    return (
        <BaseGrid container item xs={12} justifyContent="center">
            <Grid
                container
                item
                xs={12}
                sx={{
                    backgroundColor: "#00ACED",
                    color: "#fff",
                    marginBottom: "4%",
                }}
            >
                <TitleTypography>Data Referensi Kandidat</TitleTypography>
            </Grid>
            <Grid container item xs={12}>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow
                                sx={{
                                    backgroundColor: "rgba(0,0,0,0.1)",
                                }}
                            >
                                <TableCellHeader>Nama</TableCellHeader>
                                <TableCellHeader>Telepon</TableCellHeader>
                                <TableCellHeader>Hubungan</TableCellHeader>
                                <TableCellHeader>Pekerjaan</TableCellHeader>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row, key) => (
                                <StyledTableRow
                                    key={key}
                                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                    <TableCellWidth>{row.NAMA}</TableCellWidth>
                                    <TableCellWidth>{row.TELEPON}</TableCellWidth>
                                    <TableCellWidth>{row.HUBUNGAN}</TableCellWidth>
                                    <TableCellWidth>{row.PEKERJAAN}</TableCellWidth>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </BaseGrid>
    );
}
